import { createAxiosClient } from "@ntg/component-library/utilities";
import { useQuery } from "@tanstack/react-query";
import { IComparisonInfo } from "../../declarations/types";
import { IReadVerbPayload } from "../../declarations/IReadVerbPayload";

const getVatNumComparison = async (
    payload: IReadVerbPayload,
): Promise<IComparisonInfo[]> => {
    const axiosAuth = createAxiosClient("D365FO");
    const response = await axiosAuth.post<IComparisonInfo[]>(
        `/Tax/VatNumComparisonInfoD365`,
        payload,
    );
    return response.data;
};

export const useGetVatNumComparison = (
    payload: IReadVerbPayload,
) =>
{
    const dataAreaId = payload.keys.dataAreaId as string;
    const countryRegionId = payload.keys.countryRegionId as string;
    const SalesAccTaxCertID = payload.keys.salesAccTaxCertID as number;
    const vatnum = payload.keys.vatNum as string;

    return    useQuery<IComparisonInfo[]>({
        queryKey: [
            "GetVatNumComparisonInfoD365",
            {
                SalesAccTaxCertID: SalesAccTaxCertID ?? null,
                dataAreaId: dataAreaId ?? null,
                CountryRegionId: countryRegionId ?? null,
                VATNum: vatnum ?? null,
            },
        ],
        queryFn: () => {
            if (
                !SalesAccTaxCertID ||
                SalesAccTaxCertID <= 0 ||
                !dataAreaId ||
                !countryRegionId ||
                !vatnum
            ) {
                throw new Error(
                    "Invalid params for GetVatNumComparisonInfoD365",
                );
            }
            return getVatNumComparison(
            payload
            );
        },
        enabled:
            Boolean(
                !SalesAccTaxCertID ||
                    SalesAccTaxCertID <= 0 ||
                    !dataAreaId ||
                    !countryRegionId ||
                    !vatnum,
            ) === false,
        refetchOnWindowFocus: false,
        retry: false,
    });
}